import { Routes, Route } from "react-router-dom";
import WebSiteLayout from "../layouts/WebSiteLayout";
import LoginPage from "../../src/components/login/Login";
import LoginGuest from "../components/loginGuest/LoginGuest";
import RegisterSelectPage from "../../src/components/registerSelectPage/RegisterSelectPage";
import RegisterDriverPage from "../../src/components/registerDriverPage/RegisterDriverPage";
import RegisterClientPage from "../../src/components/registerClientPage/RegisterClientPage";
import ContactPage from "../../src/components/contactPage/ContactPage";
import AboutUs from "../../src/components/aboutUs/AboutUs";
import Fahrzeugübersicht from "../../src/components/fahrzeugübersicht/Fahrzeugübersicht";
import Speditionsversand from "../../src/components/speditionsversand/Speditionsversand";
import OTPVerificationPage from "../../src/components/oTPVerificationPage/OTPVerificationPage";
import ForgetPasswordPage from "../../src/components/forgetPasswordForm/ForgetPasswordForm";
import ResetPasswordPage from "../../src/components/resetPasswordForm/ResetPasswordForm";
import LandingSection from "../../src/components/landingSection/LandingSection";
import FaqVersand from "../components/faqVersand/FaqVersand";
import Kuriertransport from "../components/Kuriertransport/Kuriertransport";
import FaqPartner from "../components/faqPartner/FaqPartner";
import Transportpartner from "../components/transportpartner/Transportpartner";
import Copyright from "../components/footerPages/CopyRigtht";
import LegalNotice from "../components/footerPages/LegalNotice";
import CookiePolicy from "../components/footerPages/CookiePolicy";
import PrivacyPolicy from "../components/footerPages/PrivacyPolicy";
import Information from "../components/information/Information";
import BookingPage from "../components/booking/BookingPage";
import BookingForm from "../components/bookingForm/BookingForm";
import ClientTable from "../components/clientTable/ClientTable";
import BookingTrack from "../components/clientTable/BookingTrack";
import BookingLiveTrack from "../components/clientTable/BookingLiveTrack";
import TransportTrack from "../components/clientTable/TransportTrack";
import TransportLiveTrack from "../components/clientTable/TransportLiveTrack";

import ClientInfoForm from "../components/clientInfoForm/ClientInfoForm";
import RouteForm from "../components/movingBookingForm/RouteForm.jsx";
import TransportClientDetails from "../components/clientTable/TransportClientDetails.jsx";
import ClientDetails from "../components/clientTable/ClientDetails.jsx";
import Map from "../components/driverTable/MapPage.jsx";
import DriverDetails from "../components/driverTable/PageOne/DriverCard.jsx";
import DriverOffer from "../components/driverTable/PageTwo/DriverOffer";
import DriverRequest from "../components/driverTable/PageThree/DriverRequest";
import DriverCompleted from "../components/driverTable/PageFour/DriverCompleted";
import DriverChatModal from "../components/driverTable/DriverChatModal.jsx";
import VehicleTable from "../components/driverTable/VehicleTable.jsx";
import RechnungenClient from "../components/invoiceTableClient/RechnungenClient.jsx";
import ShipmentTimeline from "../components/shipmentTimeline/ShipmentTimeline.jsx";
import RechnungenDriver from "../components/invoiceTableDriver/RechnungenDriver.jsx";
import DriverInfoForm from "../components/DriverInfoForm/DriverInfoForm.jsx";
import HomeBooking from "../components/home/HomeBooking.jsx";
import HomeTransport from "../components/home/HomeTransport.jsx";
import ThankYou from "../pages/ThankYou";
import TransportPage from "../components/tansportPage/TransportPage.jsx";
import TransportHomeSection from "../components/transportHomeSection/TransportHomeSection.jsx";
import ExpressSectionTransport from "../components/expressSectionTransport/ExpressSectionTransport.jsx";
import TransportHomeImage from "../components/transportHomeImage/TransportHomeImage.jsx";
import DeliverySummary from "../components/movingBookingForm/DeliverySummary.jsx";
import ConfirmEmailForm from "../components/confirmEmail/ConfirmEmailForm";
import ResetPasswordGuestPage from "../components/loginGuest/ResetPasswordGuestForm";
import LoadingCities from "../components/heroSection/LoadingCities";
import CookiePolicyPage from "../components/home/CookiePolicyPage";
import DriverTerms from "../components/footerPages/DriverTerms";
import Advertisement from "../components/advertisement/Advertisement";

// Vehicle Dashboard Pages
import VehicleActiveOrders from "../components/vehicleDashboard/VehicleActiveOrders";
import VehicleCompletedOrders from "../components/vehicleDashboard/VehicleCompletedOrders";
import VehicleLogin from "../components/login/VehicleLogin";
import Umzug from "../components/umzug/umzug";
import MobelTransport from "../components/mobelTransport/mobelTransport";
import PalettenTransport from "../components/palettenTransport/palettenTransport";
import FahrzeugTransport from "../components/fahrzeugTransport/fahrzeugTransport";
import FaqUmzug from "../components/umzug/FaqUmzug";
import FaqMobel from "../components/mobelTransport/FaqMobel";
import FaqPaletten from "../components/palettenTransport/FaqPaletten";
import FaqFahrzeug from "../components/fahrzeugTransport/FaqFahrzeug";
import DataProtections from "../components/footerPages/DataProtections";
import TransportConditions from "../components/footerPages/TransportConditions";
import UserTerms from "../components/footerPages/UserTerms";
import DriverCompanyActiveOrders from "../components/driverCompanyDashboard/DriverCompanyActiveOrders";
import DriverCompanyCompletedOrders from "../components/driverCompanyDashboard/DriverCompanyCompletedOrders";
import ClientTransportsChat from "../components/chat/ClientTransportsChat";
import DriverTransportsChat from "../components/chat/DriverTransportsChat";
import DriverRatingsPage from "../components/driverTable/DriverRatingsPage";
import ClientRatingsPage from "../components/clientTable/ClientRatingsPage";
import EmployeeTable from "../components/employee/EmployeeTable";
import EmployeeBookingsTable from "../components/employeeTable/EmployeeBookingsTable";
import TransportEmployeeDetails from "../components/employeeTable/TransportEmployeeDetails";
import BookingEmployeeDetails from "../components/employeeTable/BookingEmployeeDetails";
import BookingEmployeeTrack from "../components/employeeTable/BookingEmployeeTrack";
import BookingEmployeeLiveTrack from "../components/employeeTable/BookingEmployeeLiveTrack";
import TransportEmployeeTrack from "../components/employeeTable/TransportEmployeeTrack";
import TransportEmployeeLiveTrack from "../components/employeeTable/TransportEmployeeLiveTrack";


export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<WebSiteLayout />}>
        <Route path="/" element={<HomeBooking />} />
        <Route path="/transport" element={<HomeTransport />} />
      </Route>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/vehicle-login" element={<VehicleLogin />} />
      <Route path="/login-guest" element={<LoginGuest />} />
      <Route path="/register" element={<RegisterSelectPage />} />
      <Route path="/register/driver" element={<RegisterDriverPage />} />
      <Route path="/register/client" element={<RegisterClientPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/Kurierfahrzeug" element={<Fahrzeugübersicht />} />
      <Route path="/Speditionsversand" element={<Speditionsversand />} />
      <Route path="/otp-verification" element={<OTPVerificationPage />} />
      <Route path="/forget-password" element={<ForgetPasswordPage />} />
      <Route path="/reset-password/:email/:token" element={<ResetPasswordPage />} />
      {/* <Route path="/" element={<LandingSection />} /> */}
      <Route path="/faq-versand" element={<FaqVersand />} />
      <Route path="/kuriertransport" element={<Kuriertransport />} />
      <Route path="/faq-partner" element={<FaqPartner />} />
      <Route path="/transportpartner-werden" element={<Transportpartner />} />
      <Route path="/copyright" element={<Copyright />} />
      <Route path="/legal-notice" element={<LegalNotice />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/information" element={<Information />} />
      <Route path="/bookings" element={<BookingPage />} />
      <Route path="/bookings/steps" element={<BookingForm />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="/user/booking" element={<ClientTable />} />
      <Route path="/user/booking/booking_details/:id" element={<ClientDetails />} />
      <Route path="/user/booking/booking_details/track/:booking_id" element={<BookingTrack />} />
      <Route path="/user/booking/booking_details/live-track/:id" element={<BookingLiveTrack />} />
      <Route path="/user/booking/transport_details/transport-track/:booking_id" element={<TransportTrack />} />
      <Route path="/user/booking/transport_details/transport-live-track/:id" element={<TransportLiveTrack />} />

      {/* <Route path="/user/employees" element={<EmployeeTable />} /> */}
      <Route path="/user/employees-table" element={<EmployeeTable />} />
      <Route path="/user/employees/:employeeId/booking" element={<EmployeeBookingsTable />}/>
      <Route path="/user/employees/:employeeId/booking/booking_details/:id" element={<BookingEmployeeDetails />}/>
      <Route path="/user/employees/:employeeId/booking/booking_details/track/:booking_id" element={<BookingEmployeeTrack />} />
      <Route path="/user/employees/:employeeId/booking/booking_details/live-track/:id" element={<BookingEmployeeLiveTrack />} />
      <Route path="/user/employees/:employeeId/transport/transport_details/:id" element={<TransportEmployeeDetails />}/>
       <Route path="/user/employees/:employeeId/transport/transport_details/track/:transport_id" element={<TransportEmployeeTrack />} />
      <Route path="/user/employees/:employeeId/transport/transport_details/live-track/:id" element={<TransportEmployeeLiveTrack />} />
      {/* <Route path="/user/employees/:employeeId/booking" element={<EmployeeBookingsTable />} />
      <Route path="/user/employees/:employeeId/booking" element={<EmployeeBookingsTable />} /> */}

      <Route path="/umzug" element={<Umzug />} />
      <Route path="/faq-umzug" element={<FaqUmzug />} />
      <Route path="/moebeltransport" element={<MobelTransport />} />
      <Route path="/faq-mobel" element={<FaqMobel />} />
      <Route path="/palettentransport" element={<PalettenTransport />} />
      <Route path="/faq-paletten" element={<FaqPaletten />} />
      <Route path="/fahrzeugtransport" element={<FahrzeugTransport />} />
      <Route path="/faq-fahrzeug" element={<FaqFahrzeug />} />

      <Route path="/clientinfo" element={<ClientInfoForm />} />
      <Route path="/transport-form" element={<RouteForm />} />
      <Route path="/user/booking/transport_details/:id" element={<TransportClientDetails />} />
      <Route path="/driver/driver-details" element={<DriverDetails />} />
      <Route path="/driver/driver-offer" element={<DriverOffer />} />
      <Route path="/driver/driver-request" element={<DriverRequest />} />
      <Route path="/driver/driver-completed" element={<DriverCompleted />} />
      <Route path="/driver/map" element={<Map />} />
      <Route path="/driver/driver-info" element={<DriverInfoForm />} />
      <Route path="/driver/transport-chat" element={<DriverTransportsChat />} />
      <Route path="/driver/driver-ratings" element={<DriverRatingsPage />} />
      <Route path="/rechnungen-client" element={<RechnungenClient />} />
      <Route path="/transport-chat" element={<ClientTransportsChat />} />
      <Route path="/client-ratings" element={<ClientRatingsPage />} />
      <Route path="/shipment-timeline" element={<ShipmentTimeline />} />
      <Route path="/driver/vehicle-table" element={<VehicleTable />} />
      <Route path="/driver/rechnungen-driver" element={<RechnungenDriver />} />
      <Route path="/driver/advertisement" element={<Advertisement/>}/>
      <Route path="/transport-page" element={<TransportPage />} />
      <Route path="/express-transport" element={<ExpressSectionTransport />} />
      <Route path="/transport-home-section" element={<TransportHomeSection />} />
      <Route path="/transport-home-image" element={<TransportHomeImage />} />
      <Route path="/driver-chat-modal" element={<DriverChatModal />} />
      <Route path="/delivery-summary" element={<DeliverySummary />} />
      <Route path="/confirm-email" element={<ConfirmEmailForm />} />
      <Route path="/set-password" element={<ResetPasswordGuestPage />} />
      <Route path="/loading-city" element={<LoadingCities/>}/>

      <Route path="/cookie-policy" element={<CookiePolicyPage />} />
      <Route path="/user-terms" element={<UserTerms />} />
      <Route path="/driver-terms" element={<DriverTerms />} />
      <Route path="/data-protections" element={<DataProtections />} />
      <Route path="/transport-conditions" element={<TransportConditions />} />

      <Route path="/vehicle/active-orders" element={<VehicleActiveOrders />} />
      <Route path="/vehicle/completed-orders" element={<VehicleCompletedOrders />} />

      <Route path="/driver-company/active-orders" element={<DriverCompanyActiveOrders />} />
      <Route path="/driver-company/completed-orders" element={<DriverCompanyCompletedOrders />} />
    </Routes>
  );
}
